import { invokeApi } from "../../bl_libs/invokeApi";

export const tickestsListAPI = async (data) => {
  const requestObj = {
    path: `api/support_ticket/get_filtered_list_support_ticket`,
    method: "POST",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
    postData: data,
  };
  return invokeApi(requestObj);
};
